import { render, staticRenderFns } from "./Ecs.vue?vue&type=template&id=39408940"
import script from "./Ecs.vue?vue&type=script&lang=js"
export * from "./Ecs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports